<template>
  <b-form-invalid-feedback
    :force-show="hasErrors"
  >
  {{ $t('forms.correct_form_errors')}}:
    <ul>
      <li v-for="(error, index) in activeErrorMessages" :key="index">{{ error }}</li>
    </ul>
  </b-form-invalid-feedback>  
</template>
<script>
import { multiErrorExtractorMixin } from "vuelidate-error-extractor";
export default {
  name: "FormSummary",
  extends: multiErrorExtractorMixin
};
</script>
